/**
 * HRNext Performance WebApi
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { LinqService, QueryOptions } from 'linquest';

import { IAjaxProvider } from 'jinqu';

/** Gelişim envanteri seçenek (cevap) modeli. Vizyon, Odak vb. listeler için ortak. */
export interface InventoryOptionDto {
  id?: string;
  name?: string;
  description?: string;
  isActive?: boolean;
  companyId?: string;
  createdDateUTC?: string;
  createdUserId?: string;
}

export interface EmployeeInventoryConfigurationDto {
  isDismissed?: boolean;
  isCompleted?: boolean;
  ignoreCount?: number;
}

/**
 * Çalışanın gelişim envanteri cevaplarının kaydedilmesi için kullanılan model.
 * `description` ilk adımdaki serbest metin; `<alanAdı>Description` alanları ise
 * seçeneklerin altındaki opsiyonel açıklama metinleridir.
 */
export interface EmployeeInventoryResponseDto {
  employeeId?: string;
  description?: string;
  inventoryVisionId?: string;
  inventoryVisionDescription?: string;
  inventoryFocusId?: string;
  inventoryFocusDescription?: string;
  inventoryMotivationId?: string;
  inventoryMotivationDescription?: string;
  inventoryDevelopmentId?: string;
  inventoryDevelopmentDescription?: string;
  inventoryBarrierId?: string;
  inventoryBarrierDescription?: string;
  responseDate?: Date;
}

/**
 * InventoryApi - Gelişim envanteri uçlarını tek bir API sınıfında toplar.
 */
export class InventoryApi extends LinqService {

  /**
   * Creates a new InventoryApi class.
   *
   * @param ajaxProvider The Linquest Ajax Provider to inject. When not specified, default Fetch provider will be used.
   */
  constructor(ajaxProvider?: IAjaxProvider) {
    super("/performance-api", ajaxProvider);
  }

  /**
   * Çalışanın mevcut profil metnini getirir.
   */
  getEmployeeProfileInfo(options?: QueryOptions) {
    // create query
    const url = `/EmployeeInventoryProfile/GetEmployeeProfileInfo`;
    let query = this.createQuery<string>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * Vizyon adımı seçeneklerini getirir.
   */
  listVisionTranslated(options?: QueryOptions) {
    // create query
    const url = `/InventoryVision/ListTranslated`;
    let query = this.createQuery<InventoryOptionDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * Odak adımı seçeneklerini getirir.
   */
  listFocusTranslated(options?: QueryOptions) {
    // create query
    const url = `/InventoryFocus/ListTranslated`;
    let query = this.createQuery<InventoryOptionDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * Motivasyon adımı seçeneklerini getirir.
   */
  listMotivationTranslated(options?: QueryOptions) {
    // create query
    const url = `/InventoryMotivation/ListTranslated`;
    let query = this.createQuery<InventoryOptionDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * Gelişim adımı seçeneklerini getirir.
   */
  listDevelopmentTranslated(options?: QueryOptions) {
    // create query
    const url = `/InventoryDevelopment/ListTranslated`;
    let query = this.createQuery<InventoryOptionDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * Bariyer adımı seçeneklerini getirir.
   */
  listBarrierTranslated(options?: QueryOptions) {
    // create query
    const url = `/InventoryBarrier/ListTranslated`;
    let query = this.createQuery<InventoryOptionDto>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query;
  }

  /**
   * Oturumdaki kullanıcının gelişim envanteri config kaydını getirir.
   * localStorage boşken çapraz-cihaz senkronizasyonu için kullanılır.
   */
  getCurrentConfig(options?: QueryOptions) {
    const url = `/EmployeeInventoryConfiguration/GetCurrentConfig`;
    let query = this.createQuery<EmployeeInventoryConfigurationDto>(url);

    options = options || {};
    options.method = options.method || 'GET';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * Kullanıcı soruları tamamlamadan envanteri kapattığında ignore sayacını artırır.
   * 3. kapanışta backend IsDismissed=true atar.
   */
  incrementIgnoreCount(options?: QueryOptions) {
    const url = `/EmployeeInventoryConfiguration/IncrementIgnoreCount`;
    let query = this.createQuery<any>(url);

    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    query = query.withOptions(options);

    return query.firstAsync();
  }

  /**
   * Çalışanın gelişim envanteri cevaplarını kaydeder.
   * @param dto
   */
  saveResponse(dto?: EmployeeInventoryResponseDto, options?: QueryOptions) {
    // create query
    const url = `/EmployeeInventoryResponse/SaveAsync`;
    let query = this.createQuery<any>(url);

    // initialize options
    options = options || {};
    options.method = options.method || 'POST';
    options.params = options.params || [];
    options.headers = options.headers || {};

    // set body parameter
    options.data = dto;
    query = query.withOptions(options);

    return query.firstAsync();
  }
}
